export const CompanyTheme = {
   
    POST_COMPANYTHEME: "POST_COMPANYTHEME",

}
